import React, {
  DetailedHTMLProps,
  AnchorHTMLAttributes,
  forwardRef,
  ReactElement,
  cloneElement,
} from 'react';
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import classnames from 'classnames';

import styles from './index.module.css';

export type RSIconButtonAnchorProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  icon: ReactElement;
};

export const RSIconButtonAnchor = forwardRef<
  HTMLAnchorElement,
  RSIconButtonAnchorProps
>(({ icon, ...props }, ref) => {
  const { isFocusVisible, focusProps } = useFocusRing();

  const color = '#0066FF';

  // propsとして渡すiconのviewBoxなどを指定しなくてもcloneして固定する
  const clonedIcon = cloneElement(icon, {
    className: 'block group-disabled:fill-gray-200',
    // cloneElementを用いるとstyled-jsxが利用できないため
    style: { fill: color },
    width: 32,
    height: 32,
    viewBox: '0 0 48 48',
  });

  return (
    <>
      <div
        className={classnames(
          'wrapper',
          isFocusVisible && 'focus-visible',
          'inline-block',
          'relative',
          'h-56',
          'w-56',
          'rounded-15',
          'after:transition',
        )}
      >
        <a
          {...mergeProps(props, focusProps)}
          ref={ref}
          className={classnames(
            'relative',
            'box-border',
            'w-full',
            'h-full',
            'border',
            'border-solid',
            'border-gray-200',
            'bg-white',
            'text-blue-700',
            'rounded-15',
            'flex',
            'justify-center',
            'items-center',
            'transition',
            'z-1',
            'outline-none',
            'focus:outline-none',
            styles['button-default'],
          )}
        >
          {clonedIcon}
        </a>
      </div>
      <style jsx>{`
        .wrapper::after {
          content: '';
          box-sizing: border-box;
          position: absolute;
          width: calc(100% + 8px);
          height: calc(100% + 8px);
          top: -4px;
          left: -4px;
          border-style: solid;
          border-width: 2px;
          border-color: transparent;
          border-radius: 18px;
        }

        .wrapper.focus-visible::after {
          border-color: ${color};
        }
      `}</style>
    </>
  );
});

RSIconButtonAnchor.displayName = 'RSIconButtonAnchor';
